export class AuthModel {
    email: string;
    password: string;
 }